





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';

import ChartLine from './chart-line.vue';

@Component({
  components: { ChartLine },
})
export default class ComparisonCharts extends Vue {
  @Prop() private chartSource: any;
  @Getter('intervalTime') private intervalTime: any;
}
